import { HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { UiService } from '@services/ui/ui.service'
import { PcStatusOverlayService } from '@shared/services/pc-status-overlay/pc-status-overlay.service'
import { IamStore } from 'src/app/modules/proficloud/stores/iam.store'

@Component({
  selector: 'app-invitation-callback',
  templateUrl: './invitation-callback.component.html',
  styleUrls: ['./invitation-callback.component.scss'],
})
export class InvitationCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private iamStore: IamStore,
    public router: Router,
    private statusOverlay: PcStatusOverlayService,
    private ui: UiService
  ) {}

  ngOnInit(): void {
    const invitationId = this.route.snapshot.queryParamMap.get('invitationId')
    const organizationId = this.route.snapshot.queryParamMap.get('organizationId')

    if (invitationId && organizationId) {
      this.iamStore.acceptInvitation(organizationId, invitationId).subscribe({
        next: () => {
          this.statusOverlay.showStatus(this.ui.statusOverlays.acceptInvitationSuccess)
          this.router.navigate(['/services/device-management/list'])
        },
        error: (err: HttpErrorResponse) => {
          console.log(err)
          this.statusOverlay.showStatus(this.ui.statusOverlays.acceptInvitationError)
          setTimeout(() => {
            this.router.navigate(['/services/device-management/list'])
          }, 3000)
        },
      })
    }
  }
}
